import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Button, IcoSearch } from '../../component';
import CitySelect from './citySelect';

import './searchAddress.scss';
import useSelectedCity from '../../shared/hooks/useSelectedCity';

function SearchAddress() {
  const {
    preference,
    profileRules: { hasAccessGeneralMarkets },
  } = useSelector((state: any) => state.layoutState);

  const nls = require(`../dashboard/nls/${preference.language.id}.json`);

  useSelectedCity();

  return (
    <div className="box-search">
      {hasAccessGeneralMarkets ? <CitySelect /> : null}
      <div className={'box-input-search active'}>
        <input
          data-cy="AdressSearchInput"
          type="text"
          id="input-searchbox"
          className="input"
          placeholder={nls.actionsMap.search.placeholder}
        />
      </div>
      <Button
        cy={'MapActionSearch'}
        className={'active btn circle normal medium'}
      >
        <IcoSearch cy="AddressSearchIcon" />
      </Button>
    </div>
  );
}

export default SearchAddress;
